import useAppData from "../hooks/useAppData";

const TermsAndCondition = () => {
	const { termPage } = useAppData();
	return (
		<>
			<title>{termPage.meta_title}</title>
			<meta name="description" content={termPage.meta_description} />
			<meta name="keywords" content={termPage.meta_keywords} />

			<div>
				<div className="bg-white h-30"></div>
				{/* 2. Content Layer */}
				<div>
					<div className="container mx-auto px-6 py-16">
						<div className="max-w-4xl mx-auto">
							{/* 3. The Prose Container - This styles your raw HTML */}
							<article
								className="prose prose-slate max-w-none 
               					md:prose-lg
               					prose-headings:Ethnocentric prose-headings:uppercase prose-headings:tracking-tight
               					prose-h2:Ethnocentric prose-h2:text-black prose-h2:border-b prose-h2:pb-2
               					prose-p:text-sm md:prose-p:text-base prose-p:leading-relaxed prose-p:text-gray-600
               					prose-strong:text-gray-900
               					prose-li:marker:text-brand-500"
								dangerouslySetInnerHTML={{ __html: termPage.content }}
							/>

							{/* Last Updated Footer */}
							<div className="mt-20 pt-8 border-t border-gray-100 text-center text-gray-400 text-sm">
								<p>
									If you have questions about this policy, please contact our
									legal team.
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* 4. Footer Spacer (Ensures content covers the fixed hero at the end) */}
				<div className="bg-white h-20"></div>
			</div>
		</>
	);
};

export default TermsAndCondition;
